import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { CalendarIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full py-20 md:py-28 px-4 sm:px-6 flex justify-center bg-carbon border-t border-border/50" data-id="element-114">
      <div className="max-w-4xl w-full text-center flex flex-col items-center" data-id="element-115">
        <motion.h2 className="text-gold text-3xl sm:text-4xl lg:text-5xl font-bold mb-10 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-116">
          Tu flota debería estar trabajando todos los días. No solo en verano.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full sm:w-auto flex flex-col items-center" data-id="element-117">
          <CTAButton className="w-full sm:w-auto" data-id="element-118">
            LLENA MI CALENDARIO DE MUDANZAS
          </CTAButton>
          <div className="flex items-center gap-2 mt-4" data-id="element-119">
            <span className="text-muted text-sm" data-id="element-120">O agenda directamente:</span>
            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-gold text-sm font-semibold hover:underline inline-flex items-center gap-1.5" data-id="element-121">
              <CalendarIcon className="w-4 h-4" data-id="element-122" />
              Google Calendar
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}